import React from 'react';

const DropdownMenuDivider = () => {
    return (
        <li>
            <hr className="yat-dashboard-top-bar-user-navigation__divider" />
        </li>
    );
};

export default DropdownMenuDivider;
